const triggerIfVisible = (selector, placeholderClass, cb) => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  };

  const target = document.querySelector(selector);
  if (null === target) return;

  target.classList.add(placeholderClass);

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(target);
        target.classList.remove(placeholderClass);
        cb();
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, options);
  observer.observe(target);
};

export default triggerIfVisible;
